















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import * as auth from "../../_store/auth.module";
import ActivityDataTable from "../../components/DataTables/ActivityDataTable.vue";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    CardTitle,
    ActivityDataTable
  }
})
export default class ListaAttivita extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;

  private listaAttivita: any;

  constructor() {
    super();
    this.titleParams = {
      title: "Elenco Attività",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Nome Attività",
          value: "nomeAttivita"
        },
        {
          text: "Tipo Attività",
          value: "descrizioneTipoAttivita"
        },
        {
          text: "Data Inizio",
          value: "dataInizioAttivita"
        },
        {
          text: "Data Fine",
          value: "dataFineAttivita"
        },
        {
          text: "Dettagli Attività",
          value: "dettagliAttivita"
        },
        {
          text: "Modifica Attività",
          value: "editAttivita"
        },
        // {
        //     text: "Assicurazione",
        //     value: "nomeAssicurazione"
        // },
        // {
        //     text: "Numero Assicurazione",
        //     value: "numeroAssicurazione"
        // },
        {
          text: "Apertura Iscrizione",
          value: "aperturaIscrizione"
        },
        {
          text: "Pubblica",
          value: "pubblicazione"
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ATTIVITA'",
        type: "attivita"
      },
      filterType: "listaAttivita"
    };
    this.createDialogParams = {
      visible: true,
      type: "nuovaAttivita"
    };
  }

  loadActivityList(idAnnoScolastico: number) {
    //var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"])
    var userInfo = user.readUserInfo(this["$store"]);
    var payload = {
      idIstituto: 0,
      idAnnoScolastico: idAnnoScolastico
    };
    var instituteInfo = user.readInstituteInfo(this["$store"]);
    payload = {
      idIstituto: instituteInfo.id,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchListaAttivitaIstituto(this["$store"], payload)
      .then(result => {
        this.listaAttivita = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetInstituteInfo(this["$store"])
          .then(() => {
            this.loadActivityList(idAnnoScolastico);
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("editedAttivita", () => {
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
      this.loadActivityList(idAnnoScolastico);
    });

    bus.$on("createdAttivita", () => {
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
      this.loadActivityList(idAnnoScolastico);
    });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadActivityList(payload);
    });

    bus.$on("filtroAttivita", (filters: any) => {
      const listaAttivita: any = this.listaAttivita;
      var tempList: any = [];
      this.dataTableParams.records = [];
      listaAttivita.forEach((attivita: any) => {
        if (filters.filtroTipoAttivita !== "Tutti") {
          if (filters.filtroTipoAttivita === "Tirocini Estivi") {
            if (attivita.idTipoAttivita === 1) {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Tirocini Formativi") {
            if (attivita.idTipoAttivita === 4) {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Tirocini Re/Inserimento") {
            if (attivita.idTipoAttivita === 6) {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "FSL Estiva") {
            if (attivita.idTipoAttivita === 2) {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Workshop") {
            if (attivita.idTipoAttivita === 5) {
              tempList.push(attivita);
            }
          }
          if (filters.filtroTipoAttivita === "Colloqui CV") {
            if (attivita.idTipoAttivita === 3) {
              tempList.push(attivita);
            }
          }
        } else {
          tempList.push(attivita);
        }
      });
      this.dataTableParams.records = tempList;
    });
  }
}
